/**
 * @generated SignedSource<<0b8ce7675cbedd8db9b58e6ace767efe>>
 * @relayHash 40a4fdce9c23afe4d5af8a33db34a9d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 12c380ec2406ed77b7c2028afd2901fe4a2e9b732c54892d7beaa2d24ead7273

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBoardQuery } from './JiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<JiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "12c380ec2406ed77b7c2028afd2901fe4a2e9b732c54892d7beaa2d24ead7273",
    "metadata": {},
    "name": "JiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
